import React from 'react';
import PropTypes from 'prop-types';

import { PrsDefaultButton } from '../../../../../../styles-and-themes/styles/prsButtons';
import { ButtonsContainer } from './NextButtonControlSetStyles';

const NextButtonControlSet = ({ onNext, isFormValid }) => (
  <ButtonsContainer>
    <PrsDefaultButton className="next-button" onClick={onNext} disabled={!isFormValid}>Next</PrsDefaultButton>
  </ButtonsContainer>
);

NextButtonControlSet.propTypes = {
  onNext: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
};

export default NextButtonControlSet;
